import React from 'react'
export const getPreviewBlocks = (blocks, maxTextComponents = 2, charLimit = 550) => {
    const preview = []
    let count = 0
    let charCount = 0

    function truncateHtmlText(html, limit) {
        const div = document.createElement('div')
        div.innerHTML = html
        const text = div.textContent || div.innerText || ''
        return text.slice(0, limit) + '...'
    }

    function traverse(block) {
        if (count >= maxTextComponents) return

        if (block.component?.name === 'Text') {
            const htmlText = block.component.options?.text || ''
            const plainText = (() => {
                const div = document.createElement('div')
                div.innerHTML = htmlText
                return (
                    <div
                        className="your-preview-text-styles"
                        dangerouslySetInnerHTML={{__html: block.component.options.text}}
                    ></div>
                )
            })()

            if (plainText.length > charLimit) {
                const truncatedText = truncateHtmlText(htmlText, charLimit)
                const clonedBlock = JSON.parse(JSON.stringify(block))
                clonedBlock.component.options.text = `<p>${truncatedText}</p>`
                preview.push(clonedBlock)
            } else {
                preview.push(block)
            }

            count++
            charCount += plainText.length
        }

        if (block.children) {
            for (const child of block.children) {
                traverse(child)
                if (count >= maxTextComponents) break
            }
        }
    }

    for (const block of blocks) {
        traverse(block)
        if (count >= maxTextComponents) break
    }

    return preview
}
